import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import { useGetAvailableBalance } from "../../../lib/queries/queriesAndMutations";
import { api } from "../../../utils/axios/Config";
import { handleErrorApi } from "../../../utils/utils";
import Loader from "../../shared/Loader";
import Button from "../../ui/Button";
import Hint from "../Hint";

const NewSettlment = () => {
  const [isLoading, setIsLoading] = useState(false);

  const wallet_id = useSelector((store) => store.bussinessSlice.data?.business?.wallet_id);

  const { data, refetch } = useGetAvailableBalance({ wallet_id });

  const formattedBalance =
    typeof data?.available_balance === "number" ? (
      data?.available_balance.toLocaleString()
    ) : (
      <div className="w-4 h-4 mx-2">
        <Loader />
      </div>
    );

  const handleNewSettlement = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    try {
      setIsLoading(true);

      const response = await api.post(`/wallets/settlements/`, {
        wallet_id: wallet_id,
      });

      if (response?.status === 200) {
        toast.success(`درخواست تسویه به مبلغ ${formattedBalance} ریال ثبت گردید.`);
        refetch();
      }
    } catch (error) {
      handleErrorApi(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full h-full flex flex-col-reverse md:flex-row bg-neutral-10 p-2 gap-2 overflow-y-scroll vanda">
      <div className="w-full md:w-[66%] bg-neutral-00 rounded-v-2xl h-fit">
        <h1 className="p-4 text-title-lg-semibold">تسویه جدید</h1>

        <form className="p-4 my-4 flex flex-col gap-6 justify-center items-end">
          <div className="w-full flex-between">
            <div>مبلغ قابل تسویه :</div>
            <div className="flex justify-end items-center text-title-lg-semibold p-4 gap-[0.5px] bg-neutral-20 h-12 rounded-v-lg mt-2">
              <p className="mx-[0.5px]">{formattedBalance}</p>
              ریال
            </div>
          </div>

          <Button
            type="button"
            disabled={isLoading}
            className="bg-dark text-white px-8 py-2 text-[18px] hover:bg-blue-500 disabled:bg-gray-400"
            onClick={handleNewSettlement}
          >
            {isLoading ? (
              <div className="flex items-center gap-3">
                <span className="text-sm">در حال انجام</span>
                <div className="w-4 h-4">
                  <Loader />
                </div>
              </div>
            ) : (
              "تسویه"
            )}
          </Button>
        </form>
      </div>

      <div className="md:w-[34%]">
        <Hint
          hintStyle={"entry"}
          response={"mobile"}
          hintImage={true}
          title={"راهنما"}
          entry={""}
          imagestyle={"desktop"}
        >
          <ul>
            <li className="text-title-sm-regular mb-4">
              در صورتی که به صورت حقیقی (یا حقوقی) در ونداپرداخت ثبت کسب‌وکار می‌کنید، شبای شما باید متصل به
              حساب کسب‌وکار حقیقی (یا حقوقی) شما باشد.
            </li>
            <li className="text-title-sm-regular">
              طبق اعلامیه شاپرک، صاحب حسابی که شماره‌شبا آن را وارد می‌نمایید باید با دارنده کدملی و مالک
              شماره تلفن همراه یکسان باشد.
            </li>
          </ul>
        </Hint>
      </div>
    </div>
  );
};

export default NewSettlment;
